import {db} from "../../../Firebase";
import {AUTH_USER, SHOW_SNACKBAR} from "../../type";
import * as firebase from "firebase";
import {getDateWithHourMnSeconds} from "../../calcul/getDate";


/**
 * This function will add a post on the google map
 * @param values        {object} :  contain login's and password's values
 * @param auth          {object} :  user's data
 * @param saveInUser
 * @returns             {function(...[*]=)}
 */
export const createPost = (values, auth, saveInUser) => async dispatch => {
    let isLoginAlreadyExist = false;
    try {
        //region check if pseudo or mail is already used
        if (auth && auth.post) {
            const even = (element) => element.informations.login === values.login;
            if (auth.post.some(even)) {
                isLoginAlreadyExist = true
            }
        }

        if (isLoginAlreadyExist) {
            dispatch({
                type: SHOW_SNACKBAR,
                payload: {txt: 'Login déja existant', variant: "error"}
            })
        }
        //endregion

        // check if the current user have rights to add a new post
        else if (auth.type !== 'company' && auth.type !== 'admin') {
            console.log('vous ne pouvez pas réaliser cette action');
            return false;
        }

        // there we will add a new post
        else {
            values['date_post'] = new Date(getDateWithHourMnSeconds( Date.now() ));
            values['date_start'] = new Date(values.informations.date_start);
            values['date_end'] = new Date(values.informations.date_end);
            await db.collection("destockage_post").add(values).then( (docRef) => {})
                .catch((error) => {
                dispatch({
                    type: SHOW_SNACKBAR,
                    payload: {txt: "Votre annonce ne peut pas être enregistrée", variant: "error"}
                });
            });

            if (saveInUser) {
                //region get user's id from firestore
                let id = "";
                await db.collection("utilisateurs").where("pseudo", "==", auth.pseudo).get().then((querySnapshot) => {
                    querySnapshot.forEach((doc) => {
                        id = doc.id;
                    });
                }).catch(e => {
                    console.log(e);
                });
                //endregion

                let userRef = db.collection("utilisateurs").doc(id);

                userRef.update({post: firebase.firestore.FieldValue.arrayUnion(values)}).then(async () => {
                    dispatch({
                        type: SHOW_SNACKBAR,
                        payload: {txt: "Votre annonce à bien été posté et enregistré ", variant: "success"}
                    });
                    await userRef.get().then((doc) => {
                        let user = doc.data();
                        dispatch({type: AUTH_USER, payload: user});
                    }).catch(e => {
                        console.log(e);
                    })
                }).catch((error) => {
                    dispatch({
                        type: SHOW_SNACKBAR,
                        payload: {
                            txt: "Votre annonce ne peut pas être enregistrée dans la section vos annonces",
                            variant: "error"
                        }
                    });
                })
            } else {
                dispatch({
                    type: SHOW_SNACKBAR,
                    payload: {txt: "Votre annonce à bien été posté ", variant: "success"}
                });
                return values;
            }
        }
    } catch (e) {
        dispatch({type: SHOW_SNACKBAR, payload: {txt: "Votre annonce ne peut pas être enregistrée", variant: "error"}});
    }
};


